import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonView = ({
  iconEye,
  funcion,
  data,
  link,
  style,
  className,
  disabled,
  text,
  justify,
  tooltipText,
  tooltipPosition,
  ...rest
}) => {
  return !link ? (
    text ? (
      <Button
        className={
          className + ' d-flex align-items-center justify-content-center'
        }
        variant={!disabled ? 'light' : 'secondary'}
        size="sm"
        disabled={disabled}
        onClick={data ? () => funcion(data) : funcion}
        type="submit"
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <div
          className={`w-100 d-flex align-items-center justify-content-${justify} gap-1`}
        >
          <FontAwesomeIcon
            icon="external-link-alt"
            style={{ marginRight: 5 }}
          />
          <span style={{ marginRight: 10 }}>{text}</span>
        </div>
      </Button>
    ) : (
      <OverlayTrigger
        placement={tooltipPosition || 'bottom'}
        overlay={<Tooltip>{tooltipText || 'Ver'}</Tooltip>}
      >
        <span>
          <IconButton
            buttonSize="sm"
            style={{ width: 30, ...style }}
            icon={iconEye ? 'eye' : 'external-link-alt'}
            onClick={
              !disabled ? (data ? () => funcion(data) : funcion) : () => {}
            }
            variant="light"
            className={'px-2' + ' ' + className}
            disabled={disabled}
            {...rest}
          />
        </span>
      </OverlayTrigger>
    )
  ) : text ? (
    !disabled ? (
      <Link to={link} target="_blank" style={{ textDecoration: 'none' }}>
        <Button
          className={
            className + ' d-flex align-items-center justify-content-center'
          }
          variant={!disabled ? 'light' : 'secondary'}
          size="sm"
          disabled={disabled}
          onClick={data ? () => funcion(data) : funcion}
          type="submit"
          style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
          <div
            className={`w-100 d-flex align-items-center justify-content-${justify} gap-1`}
          >
            <FontAwesomeIcon
              icon="external-link-alt"
              style={{ marginRight: 5 }}
            />
            <span style={{ marginRight: 10 }}>{text}</span>
          </div>
        </Button>
      </Link>
    ) : (
      <Button
        className={
          className + ' d-flex align-items-center justify-content-center'
        }
        variant={!disabled ? 'light' : 'secondary'}
        size="sm"
        disabled={disabled}
        onClick={data ? () => funcion(data) : funcion}
        type="submit"
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <div
          className={`w-100 d-flex align-items-center justify-content-${justify}`}
        >
          <FontAwesomeIcon
            icon="external-link-alt"
            style={{ marginRight: 5 }}
          />
          <span style={{ marginRight: 10 }}>{text}</span>
        </div>
      </Button>
    )
  ) : (
    <OverlayTrigger
      placement={tooltipPosition || 'bottom'}
      overlay={<Tooltip>{tooltipText || 'Ver'}</Tooltip>}
    >
      <span>
        {!disabled ? (
          <Link to={link} target="_blank">
            <IconButton
              buttonSize="sm"
              style={{ width: 30, ...style }}
              icon={iconEye ? 'eye' : 'external-link-alt'}
              variant="light"
              className={'px-2' + ' ' + className}
              {...rest}
            />
          </Link>
        ) : (
          <IconButton
            buttonSize="sm"
            style={{ width: 30, ...style }}
            icon={iconEye ? 'eye' : 'external-link-alt'}
            variant="light"
            className={'px-2' + ' ' + className}
            disabled
            {...rest}
          />
        )}
      </span>
    </OverlayTrigger>
  );
};

ButtonView.propTypes = {
  funcion: PropTypes.func,
  data: PropTypes.any,
  link: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  iconEye: PropTypes.bool,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  justify: PropTypes.oneOf(['start', 'center', 'end']),
  tooltipText: PropTypes.string,
  tooltipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
};

ButtonView.defaultProps = {
  justify: 'center'
};

export default ButtonView;
